export const OWNER_ADMIN = "owner_admin";
export const MANAGER = "manager";
export const CASHIER = "cashier";
export const INVENTORY_MANAGER = "inventory_manager";
export const SALES_EXECUTIVE = "sales_executive";
export const ACCOUNTANT = "accountant";
export const DELIVERY_PERSONNEL = "delivery_personnel";
export const ADMIN = "admin";
export const RESELLER = "reseller";
